module.exports = __webpack_public_path__ + "img/join-us.94136f2.png";